"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = AllocationModal;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const Tools_1 = __importDefault(require("../../React/Tools/Tools"));
const ToolsDate_1 = __importDefault(require("../../React/Tools/ToolsDate"));
const BankSyncController_1 = require("./BankSyncController");
async function searchInvoices(query) {
    const res = await fetch(`${MainSetupReact_1.default.serverUrl}invoices`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orConditions: [{ searchText: query }] }),
    });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return Array.isArray(data) ? data : [];
}
async function searchCostInvoices(query) {
    const res = await fetch(`${MainSetupReact_1.default.serverUrl}cost-invoices`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ orConditions: [{ searchText: query }] }),
    });
    if (!res.ok)
        throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return Array.isArray(data) ? data : [];
}
function AllocationModal({ transfer, onHide, onChanged }) {
    const [invoiceType, setInvoiceType] = (0, react_1.useState)('invoice');
    const [searchQuery, setSearchQuery] = (0, react_1.useState)('');
    const [searching, setSearching] = (0, react_1.useState)(false);
    const [invoiceResults, setInvoiceResults] = (0, react_1.useState)([]);
    const [costInvoiceResults, setCostInvoiceResults] = (0, react_1.useState)([]);
    const [selectedInvId, setSelectedInvId] = (0, react_1.useState)(null);
    const [selectedCostInvId, setSelectedCostInvId] = (0, react_1.useState)(null);
    const [amount, setAmount] = (0, react_1.useState)(String(transfer.amount));
    const [saving, setSaving] = (0, react_1.useState)(false);
    const [error, setError] = (0, react_1.useState)(null);
    const [allocations, setAllocations] = (0, react_1.useState)([]);
    const [loadingAllocs, setLoadingAllocs] = (0, react_1.useState)(true);
    const [deletingId, setDeletingId] = (0, react_1.useState)(null);
    const searchTimer = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        (0, BankSyncController_1.fetchAllocations)(transfer.id)
            .then(setAllocations)
            .catch(() => { })
            .finally(() => setLoadingAllocs(false));
    }, [transfer.id]);
    (0, react_1.useEffect)(() => {
        if (selectedInvId || selectedCostInvId)
            return;
        if (searchTimer.current)
            clearTimeout(searchTimer.current);
        if (!searchQuery.trim()) {
            setInvoiceResults([]);
            setCostInvoiceResults([]);
            return;
        }
        let cancelled = false;
        searchTimer.current = setTimeout(async () => {
            setSearching(true);
            try {
                if (invoiceType === 'invoice') {
                    const res = await searchInvoices(searchQuery);
                    if (!cancelled) {
                        setInvoiceResults(res);
                        setCostInvoiceResults([]);
                    }
                }
                else {
                    const res = await searchCostInvoices(searchQuery);
                    if (!cancelled) {
                        setCostInvoiceResults(res);
                        setInvoiceResults([]);
                    }
                }
            }
            catch { /* search errors are non-critical */ }
            finally {
                if (!cancelled)
                    setSearching(false);
            }
        }, 400);
        return () => { cancelled = true; if (searchTimer.current)
            clearTimeout(searchTimer.current); };
    }, [searchQuery, invoiceType, selectedInvId, selectedCostInvId]);
    function switchType(t) {
        setInvoiceType(t);
        setSearchQuery('');
        setSelectedInvId(null);
        setSelectedCostInvId(null);
        setInvoiceResults([]);
        setCostInvoiceResults([]);
    }
    const selectedId = invoiceType === 'invoice' ? selectedInvId : selectedCostInvId;
    const results = invoiceType === 'invoice' ? invoiceResults : costInvoiceResults;
    function getLabel(r) {
        return invoiceType === 'invoice'
            ? (r.number ?? `#${r.id}`)
            : (r.invoiceNumber ?? `#${r.id}`);
    }
    function getParty(r) {
        return invoiceType === 'invoice'
            ? (r._entity?.name ?? '')
            : (r.supplierName ?? '');
    }
    function getGross(r) {
        return invoiceType === 'invoice'
            ? (r._totalGrossValue ?? 0)
            : r.grossAmount;
    }
    function selectResult(r) {
        if (invoiceType === 'invoice')
            setSelectedInvId(r.id);
        else
            setSelectedCostInvId(r.id);
        setSearchQuery(getLabel(r));
    }
    const selectedResult = results.find(r => r.id === selectedId)
        ?? (invoiceType === 'invoice'
            ? invoiceResults.find(r => r.id === selectedId)
            : costInvoiceResults.find(r => r.id === selectedId));
    async function handleSave() {
        if (!selectedId) {
            setError('Wybierz fakturę z listy');
            return;
        }
        const amountNum = parseFloat(amount.replace(',', '.'));
        if (isNaN(amountNum) || amountNum <= 0) {
            setError('Podaj prawidłową kwotę (> 0)');
            return;
        }
        setSaving(true);
        setError(null);
        try {
            await (0, BankSyncController_1.createAllocation)(transfer.id, {
                ...(invoiceType === 'invoice' ? { invoiceId: selectedId } : { costInvoiceId: selectedId }),
                amount: amountNum,
            });
            onChanged();
            const updated = await (0, BankSyncController_1.fetchAllocations)(transfer.id);
            setAllocations(updated);
            setSearchQuery('');
            setSelectedInvId(null);
            setSelectedCostInvId(null);
            setInvoiceResults([]);
            setCostInvoiceResults([]);
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Błąd zapisu');
        }
        finally {
            setSaving(false);
        }
    }
    async function handleDelete(allocId) {
        setDeletingId(allocId);
        setError(null);
        try {
            await (0, BankSyncController_1.deleteAllocation)(transfer.id, allocId);
            setAllocations(prev => prev.filter(a => a.id !== allocId));
            onChanged();
        }
        catch (e) {
            setError(e instanceof Error ? e.message : 'Błąd usuwania');
        }
        finally {
            setDeletingId(null);
        }
    }
    const canAllocate = transfer.matchingStatus !== 'MANUAL';
    const fmt = (n) => `${Tools_1.default.formatNumber(n)} PLN`;
    const fmtDate = (d) => d ? ToolsDate_1.default.dateYMDtoDMY(d) : '-';
    return (react_1.default.createElement(react_bootstrap_1.Modal, { show: true, onHide: onHide, size: "lg" },
        react_1.default.createElement(react_bootstrap_1.Modal.Header, { closeButton: true },
            react_1.default.createElement(react_bootstrap_1.Modal.Title, null,
                "Alokacje \u2014 ",
                transfer.direction === 'IN' ? '↓ IN' : '↑ OUT',
                " ",
                fmt(transfer.amount),
                " \u00A0",
                react_1.default.createElement("small", { className: "text-muted fw-normal fs-6" }, fmtDate(transfer.execDate)))),
        react_1.default.createElement(react_bootstrap_1.Modal.Body, null,
            react_1.default.createElement("p", { className: "text-muted small mb-3" },
                react_1.default.createElement("strong", null, transfer.counterpartyName ?? '-'),
                transfer.counterpartyAccount && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("br", null),
                    react_1.default.createElement("span", { className: "font-monospace" }, transfer.counterpartyAccount)),
                transfer.description && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("br", null),
                    transfer.description)),
            error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null) }, error),
            react_1.default.createElement("h6", null, "Istniej\u0105ce alokacje"),
            loadingAllocs
                ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" })
                : allocations.length === 0
                    ? react_1.default.createElement("p", { className: "text-muted small" }, "Brak alokacji dla tego przelewu")
                    : react_1.default.createElement(react_bootstrap_1.ListGroup, { className: "mb-3" }, allocations.map(a => (react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { key: a.id, className: "d-flex justify-content-between align-items-center py-2 px-3" },
                        react_1.default.createElement("div", { className: "small" },
                            a.invoiceId
                                ? react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(react_bootstrap_1.Badge, { bg: "primary", className: "me-1" }, "Faktura"),
                                    " #",
                                    a.invoiceId)
                                : react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement(react_bootstrap_1.Badge, { bg: "secondary", className: "me-1" }, "Kosztowa"),
                                    " #",
                                    a.costInvoiceId),
                            react_1.default.createElement("span", { className: "ms-2 fw-semibold" }, fmt(a.allocatedAmount)),
                            react_1.default.createElement(react_bootstrap_1.Badge, { bg: "light", text: "dark", className: "ms-2 border" }, a.source)),
                        react_1.default.createElement(react_bootstrap_1.Button, { size: "sm", variant: "outline-danger", disabled: deletingId === a.id, onClick: () => handleDelete(a.id) }, deletingId === a.id ? react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border" }) : 'Usuń'))))),
            canAllocate && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("h6", { className: "mt-3" }, "Dodaj alokacj\u0119"),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-2" },
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: "radio", label: "Faktura sprzeda\u017Cy", name: "invType", id: "invType-inv", checked: invoiceType === 'invoice', onChange: () => switchType('invoice') }),
                    react_1.default.createElement(react_bootstrap_1.Form.Check, { inline: true, type: "radio", label: "Faktura kosztowa", name: "invType", id: "invType-cost", checked: invoiceType === 'costInvoice', onChange: () => switchType('costInvoice') })),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-1" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "small mb-1" },
                        "Szukaj faktury ",
                        searching && react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border", className: "ms-1" })),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", size: "sm", placeholder: "Numer faktury lub nazwa kontrahenta\u2026", value: searchQuery, onChange: e => {
                            setSearchQuery(e.target.value);
                            setSelectedInvId(null);
                            setSelectedCostInvId(null);
                        } })),
                results.length > 0 && !selectedId && (react_1.default.createElement(react_bootstrap_1.ListGroup, { className: "mb-2", style: { maxHeight: 200, overflowY: 'auto' } }, results.slice(0, 10).map(r => (react_1.default.createElement(react_bootstrap_1.ListGroup.Item, { key: r.id, action: true, onClick: () => selectResult(r), className: "py-2" },
                    react_1.default.createElement("div", { className: "small fw-semibold" }, getLabel(r)),
                    react_1.default.createElement("div", { className: "small text-muted" },
                        getParty(r),
                        " \u2014 ",
                        fmt(getGross(r)))))))),
                selectedResult && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "success", className: "py-2 small mb-2 d-flex justify-content-between align-items-center" },
                    react_1.default.createElement("span", null,
                        react_1.default.createElement("strong", null, getLabel(selectedResult)),
                        ' — ',
                        getParty(selectedResult),
                        ' — brutto: ',
                        fmt(getGross(selectedResult))),
                    react_1.default.createElement(react_bootstrap_1.Button, { variant: "link", size: "sm", className: "p-0 ms-2 text-danger", onClick: () => { setSelectedInvId(null); setSelectedCostInvId(null); setSearchQuery(''); } }, "zmie\u0144"))),
                react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mb-3" },
                    react_1.default.createElement(react_bootstrap_1.Form.Label, { className: "small mb-1" }, "Kwota alokacji (PLN)"),
                    react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", size: "sm", step: "0.01", min: "0.01", value: amount, onChange: e => setAmount(e.target.value) })))),
            !canAllocate && (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "info", className: "small" },
                "Przelew oznaczony jako ",
                react_1.default.createElement("strong", null, "MANUAL"),
                " (op\u0142ata bankowa lub waluta obca) \u2014 alokacja r\u0119czna niedost\u0119pna."))),
        react_1.default.createElement(react_bootstrap_1.Modal.Footer, null,
            react_1.default.createElement(react_bootstrap_1.Button, { variant: "secondary", onClick: onHide }, "Zamknij"),
            canAllocate && (react_1.default.createElement(react_bootstrap_1.Button, { variant: "primary", onClick: handleSave, disabled: saving || !selectedId }, saving
                ? react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_1.Spinner, { size: "sm", animation: "border", className: "me-1" }),
                    "Zapisuj\u0119\u2026")
                : 'Zapisz alokację')))));
}
